// Campos do sistema disponíveis por entidade no Importador de Dados
// (Administrativo → Importar Dados). Mesmas chaves usadas pelo backend
// (backend/src/services/importador/*.js) — não renomear sem atualizar os dois lados.

export const ENTIDADES = [
  { id: 'produtos', label: 'Produtos' },
  { id: 'clientes', label: 'Clientes' },
  { id: 'fornecedores', label: 'Fornecedores' },
  { id: 'contas-receber', label: 'Contas a Receber' },
  { id: 'contas-pagar', label: 'Contas a Pagar' },
];

export const CAMPOS = {
  produtos: [
    { campo: 'descricao', label: 'Descrição do produto', obrigatorio: true },
    { campo: 'codigo', label: 'Código (interno do produto)' },
    { campo: 'codigo_barras', label: 'Código de barras do produto' },
    { campo: 'unidade', label: 'Unidade' },
    { campo: 'preco_custo', label: 'Preço de custo R$' },
    { campo: 'preco_venda', label: 'Preço de venda R$' },
    { campo: 'quantidade_estoque', label: 'Quantidade em estoque' },
    { campo: 'quantidade_minima_estoque', label: 'Quantidade mínima de estoque' },
    { campo: 'comissao_pct', label: 'Comissão %' },
    { campo: 'desconto_maximo_pct', label: 'Desconto máximo %' },
    { campo: 'peso_kg', label: 'Peso Kg' },
    { campo: 'ncm', label: 'NCM' },
    { campo: 'inativo', label: 'Inativo (true/false, sim/não) — some da venda/PDV até ser reativado' },
    { campo: 'marca', label: 'Marca' },
    { campo: 'grupo', label: 'Grupo' },
    { campo: 'subgrupo', label: 'SubGrupo' },
    { campo: 'fornecedor_cnpj', label: 'Fornecedor - CPF ou CNPJ' },
    { campo: 'fornecedor_nome_fantasia', label: 'Fornecedor - Nome fantasia' },
    { campo: 'fornecedor_razao_social', label: 'Fornecedor - Razão social' },
    { campo: 'observacao', label: 'Observação' },
  ],
  clientes: [
    { campo: 'nome', label: 'Nome', obrigatorio: true },
    { campo: 'cpf_cnpj', label: 'CPF ou CNPJ' },
    { campo: 'tipo_pessoa', label: 'Tipo de pessoa (F/J)' },
    { campo: 'email', label: 'E-mail' },
    { campo: 'fone1', label: 'Telefone' },
    { campo: 'cep', label: 'CEP' },
    { campo: 'logradouro', label: 'Endereço' },
    { campo: 'numero', label: 'Número' },
    { campo: 'complemento', label: 'Complemento' },
    { campo: 'bairro', label: 'Bairro' },
    { campo: 'cidade', label: 'Cidade' },
    { campo: 'estado', label: 'Estado (UF)' },
    { campo: 'limite_credito', label: 'Limite de crédito R$' },
    { campo: 'desconto_perc', label: 'Desconto %' },
    { campo: 'codigo_externo', label: 'Código no sistema anterior' },
    { campo: 'inativo', label: 'Inativo (true/false, sim/não)' },
    { campo: 'pontos_iniciais', label: 'Pontos de fidelidade — saldo inicial (só na organização atual)' },
    { campo: 'obs', label: 'Observação' },
  ],
  fornecedores: [
    { campo: 'nome_fantasia', label: 'Nome Fantasia', obrigatorio: true },
    { campo: 'razao_social', label: 'Razão Social' },
    { campo: 'cpf_cnpj', label: 'CPF ou CNPJ' },
    { campo: 'ie', label: 'Inscrição Estadual' },
    { campo: 'email', label: 'E-mail' },
    { campo: 'fone', label: 'Telefone' },
    { campo: 'contato', label: 'Nome do contato' },
    { campo: 'site', label: 'Site' },
    { campo: 'cep', label: 'CEP' },
    { campo: 'logradouro', label: 'Endereço' },
    { campo: 'numero', label: 'Número' },
    { campo: 'complemento', label: 'Complemento' },
    { campo: 'bairro', label: 'Bairro' },
    { campo: 'cidade', label: 'Cidade' },
    { campo: 'uf', label: 'Estado (UF)' },
    { campo: 'inativo', label: 'Inativo (true/false, sim/não)' },
    { campo: 'observacoes', label: 'Observações' },
  ],
  'contas-receber': [
    { campo: 'descricao', label: 'Descrição', obrigatorio: true },
    { campo: 'valor', label: 'Valor R$', obrigatorio: true },
    { campo: 'data_vencimento', label: 'Data de vencimento', obrigatorio: true },
    { campo: 'data_emissao', label: 'Data de emissão' },
    { campo: 'cliente_cpf_cnpj', label: 'Cliente - CPF ou CNPJ' },
    { campo: 'cliente_nome', label: 'Cliente - Nome' },
    { campo: 'numero_documento', label: 'Número do documento' },
    { campo: 'parcela', label: 'Parcela' },
    { campo: 'total_parcelas', label: 'Total de parcelas' },
    { campo: 'plano_conta', label: 'Categoria (Plano de Contas)' },
    { campo: 'observacoes', label: 'Observações' },
  ],
  'contas-pagar': [
    { campo: 'descricao', label: 'Descrição', obrigatorio: true },
    { campo: 'valor', label: 'Valor R$', obrigatorio: true },
    { campo: 'data_vencimento', label: 'Data de vencimento', obrigatorio: true },
    { campo: 'data_emissao', label: 'Data de emissão' },
    { campo: 'fornecedor_cnpj', label: 'Fornecedor - CPF ou CNPJ' },
    { campo: 'fornecedor_nome', label: 'Fornecedor - Nome' },
    { campo: 'numero_documento', label: 'Número do documento' },
    { campo: 'parcela', label: 'Parcela' },
    { campo: 'total_parcelas', label: 'Total de parcelas' },
    { campo: 'plano_conta', label: 'Categoria (Plano de Contas)' },
    { campo: 'observacoes', label: 'Observações' },
  ],
};
